import React, { ButtonHTMLAttributes } from "react";
import { appConfig } from "@src/config/appConfig";
import { Link } from "gatsby";
import { TypographyLinkProps } from "design-system/src/Core/Link/Context/DefaultTypographyLink";
import Typography from "design-system/src/Foundation/Typography/Typography";
import { isClientNavigable } from "./navigationRules";

const TypographyLink = (props: TypographyLinkProps) => {
  const { sushishopBaseUrl } = appConfig;
  const {
    children,
    to,
    href = "",
    color: colorProps,
    onClick,
    type,
    ...anchorRest
  } = props;
  const re = new RegExp(`^${sushishopBaseUrl}`, "i");
  const route = (to || href || "").replace(re, "");
  const javascript_uri = /^javascript:(.*)/.exec(route);
  // Seules les pages internes PWA passent par le <Link> Gatsby (routing
  // client-side). Un fichier statique (PDF, image…) ou un lien "_blank" doit être
  // servi par une navigation navigateur complète (<a> natif) — sinon 404 PWA.
  // Cf. règles partagées navigationRules.ts (régression RUN-8018).
  if (isClientNavigable(route, anchorRest.target)) {
    return (
      <Typography
        as={Link}
        to={route}
        color={colorProps}
        onClick={onClick}
        {...anchorRest}
        className={
          "typography-link-internal" + " " + (anchorRest.className || "")
        }
      >
        {children}
      </Typography>
    );
  }
  if (!route || javascript_uri) {
    const { color, ...buttonRest } = anchorRest as ButtonHTMLAttributes<any>;
    const evalJs = () => {
      eval(javascript_uri ? javascript_uri[1] : "()=>{}");
    };
    return (
      <Typography
        as={"button"}
        {...buttonRest}
        color={colorProps}
        onClick={onClick || evalJs}
        type={type}
      >
        {children}
      </Typography>
    );
  }
  return (
    <Typography
      as={"a"}
      href={route}
      color={colorProps}
      onClick={onClick}
      {...anchorRest}
      className={"typography-link-default" + " " + (anchorRest.className || "")}
    >
      {children}
    </Typography>
  );
};

export default TypographyLink;
